import Layout from "../Layout";
import Loader from "../Layout/loader";

import { useEffect, useState } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import ModalFechamento from "../PDVs/modalFechamento";

import { MdOutlineRestaurantMenu } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { FaPix } from "react-icons/fa6";
import { codigoEvento } from "../Utils/utils";

import {
  FaCreditCard,
  FaRegCreditCard,
  FaMoneyBillWave,
  FaShoppingCart,
  FaLock,
  FaClock,
  FaUser,
  FaSortAmountUp,
} from "react-icons/fa";
import ModalContent from "./modalContent";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.defaults.font.family = "Roboto, sans-serif";
ChartJS.defaults.font.size = 14;

function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [dataFechamento, setDataFechamento] = useState(null);
  const [pieGraphData, setPieGraphData] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentPDV, setCurrentPDV] = useState(null);
  const [currentTurno, setCurrentTurno] = useState(null);
  const [maxTurno, setMaxTurno] = useState(0);

  const iconSize = 16;

  async function getInfoPDVs() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/ResumoPDVs`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((response) => {
        setData(response.data);
        setIsLoading(false);
        let labelData = { funcionando: 0, alerta: 0, erro: 0, encerrado: 0 };
        const now = new Date();
        const fiveMinutesAgo = new Date(now.getTime() - 5 * 60 * 1000);
        const fifteenMinutesAgo = new Date(now.getTime() - 15 * 60 * 1000);
        response.data.forEach((cardapio) => {
          cardapio.vendasPDV.forEach((item) => {
            if (item.DATAHORAFECHAMENTO) {
              item.status = "Encerrado";
              labelData.encerrado += 1;
            } else if (new Date(item.DATAHORAULTVENDA) >= fiveMinutesAgo) {
              item.status = "Operação Normal";
              labelData.funcionando += 1;
            } else if (new Date(item.DATAHORAULTVENDA) >= fifteenMinutesAgo) {
              item.status = "PDV em Atenção";
              labelData.alerta += 1;
            } else {
              item.status = "PDV sem Conexão";
              labelData.erro += 1;
            }
          });
        });

        setPieGraphData({
          labels: [
            `Operação Normal : ${labelData.funcionando}`,
            `PDV em Atenção : ${labelData.alerta}`,
            `PDV sem Conexão : ${labelData.erro}`,
            `Encerrado : ${labelData.encerrado}`,
          ],
          datasets: [
            {
              label: "Status dos PDVs",
              data: [
                labelData.funcionando,
                labelData.alerta,
                labelData.erro,
                labelData.encerrado,
              ],
              backgroundColor: ["#00C800", "#FFD700", "#E60000", "#000000"],
              borderWidth: 1,
            },
          ],
        });
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
      });
  }

  useEffect(() => {
    getInfoPDVs();
  }, []);

  async function verInfoModal(pdv, turno, maxTurno) {
    setCurrentPDV(pdv);
    setCurrentTurno(turno);
    setMaxTurno(maxTurno);
    setModalOpen(true);
  }

  return (
    <Layout>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-4 w-full p-4 box-border">
          <div className="max-h-screen lg:max-h-76 p-4 box-border overflow-x-auto">
            <Doughnut
              data={pieGraphData}
              options={{
                plugins: {
                  legend: {
                    display: true,
                    position: "left",
                  },
                  tooltip: {
                    enabled: true,
                  },
                },
                rotation: -90,
                circumference: 180,
                responsive: true,
                maintainAspectRatio: false,
              }}
            />
          </div>

          {data.map((cardapio, i) => (
            <div
              className="flex flex-col gap-4 shadow p-4 box-border bg-gray-50"
              key={i}
            >
              {cardapio.CODIGO ? (
                <h2 className="flex gap-1 items-center font-Oswald">
                  <MdOutlineRestaurantMenu size={28} />
                  {cardapio.CODIGO} - {cardapio.DESCRICAO}
                </h2>
              ) : (
                <h2 className="font-Oswald uppercase">Sem Cardápio</h2>
              )}

              <div className="font-Roboto flex flex-wrap gap-8 sm:items-center justify-center">
                {cardapio.vendasPDV?.length === 0 ? (
                  <h2 className="text-md text-gray-300">
                    Sem vendas para esse cardápio.
                  </h2>
                ) : null}
                {cardapio.vendasPDV?.map((item, j) => (
                  <div
                    className="flex flex-col p-4 gap-4 bg-white shadow-sm border border-slate-200 rounded-lg"
                    key={j}
                  >
                    <div className="flex justify-center items-center w-full">
                      <h2
                        className={
                          (item.status === "PDV sem Conexão"
                            ? "text-[#E60000]"
                            : item.status === "Encerrado"
                            ? "text-[#000000]"
                            : item.status === "PDV em Atenção"
                            ? "text-[#FFD700]"
                            : "text-[#00C800]") +
                          " flex gap-1 items-center font-Oswald"
                        }
                      >
                        <TbReportSearch
                          className="cursor-pointer"
                          size={28}
                          onClick={() =>
                            verInfoModal(item.PDV, item.TURNO, item.TURNO)
                          }
                        />
                        {item.PDV}
                      </h2>
                    </div>

                    <hr className="m-auto w-[90%] border-none h-[2px] text-[#ccc] bg-[#ccc]" />

                    {item?.PAGAMENTOS["CREDITO"] ? (
                      <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                        <div className="flex items-center gap-1">
                          <FaCreditCard size={iconSize} />
                          <div className="absolute text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100">
                            <span>Crédito</span>
                          </div>
                        </div>
                        <span className="text-right min-w-[80px]">
                          {item?.PAGAMENTOS["CREDITO"]
                            ? item?.PAGAMENTOS["CREDITO"]?.toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            : Number(0).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                        </span>
                      </p>
                    ) : null}
                    {item?.PAGAMENTOS["DEBITO"] ? (
                      <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                        <div className="flex items-center gap-1">
                          <FaRegCreditCard size={iconSize} />{" "}
                          <div className="absolute text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100">
                            <span>Débito</span>
                          </div>
                        </div>
                        <span className="text-right min-w-[80px]">
                          {item?.PAGAMENTOS["DEBITO"]
                            ? item?.PAGAMENTOS["DEBITO"]?.toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            : Number(0).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                        </span>
                      </p>
                    ) : null}

                    {item?.PAGAMENTOS["DINHEIRO"] ? (
                      <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                        <div className="flex items-center gap-1">
                          <FaMoneyBillWave size={iconSize} />{" "}
                          <div className="absolute text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100">
                            <span>Dinheiro</span>
                          </div>
                        </div>
                        <span className="text-right min-w-[80px]">
                          {item?.PAGAMENTOS["DINHEIRO"]
                            ? item?.PAGAMENTOS["DINHEIRO"]?.toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            : Number(0).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                        </span>
                      </p>
                    ) : null}

                    {item?.PAGAMENTOS["PIX"] ? (
                      <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                        <div className="flex items-center gap-1">
                          <FaPix size={iconSize} />
                          <div className="absolute text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100">
                            <span>PIX</span>
                          </div>
                        </div>
                        <span className="text-right min-w-[80px]">
                          {item?.PAGAMENTOS["PIX"]
                            ? item?.PAGAMENTOS["PIX"]?.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : Number(0).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                        </span>
                      </p>
                    ) : null}
                    <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                      <div className="flex items-center gap-1">
                        <FaSortAmountUp size={iconSize} />{" "}
                        <p className="font-bold">Total</p>
                        <div className="absolute text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100">
                          <span>Total</span>
                        </div>
                      </div>
                      <span className="text-right font-bold min-w-[80px]">
                        {item.TOTAL
                          ? item.TOTAL?.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : Number(0).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                      </span>
                    </p>

                    <hr className="m-auto w-[90%] border-none h-[2px] text-[#ccc] bg-[#ccc]" />

                    <p className="relative overflow-visible group flex gap-1 items-center w-fit">
                      <FaClock size={iconSize} />
                      <div className="absolute text-black text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm   p-2 bg-gray-100">
                        <span>Abertura</span>
                      </div>
                      <span className="text-right">
                        {item.DATAHORAABERTURA
                          ? new Date(item.DATAHORAABERTURA).toLocaleString(
                              "pt-BR",
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              }
                            )
                          : ""}
                      </span>
                    </p>
                    {!item.DATAHORAFECHAMENTO ? (
                      <p className="relative overflow-visible group flex gap-1 w-fit items-center">
                        <FaShoppingCart size={iconSize} />
                        <div className="absolute text-black text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm   p-2 bg-gray-100">
                          <span>Última venda</span>
                        </div>
                        <span className="text-right">
                          {item.DATAHORAULTVENDA
                            ? new Date(item.DATAHORAULTVENDA).toLocaleString(
                                "pt-BR",
                                {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                }
                              )
                            : ""}
                        </span>
                      </p>
                    ) : null}
                    {item.DATAHORAFECHAMENTO ? (
                      <p className="relative overflow-visible group flex gap-1 items-center w-fit">
                        <FaLock size={iconSize} />
                        <div className="absolute text-black text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm p-2 bg-gray-100 ">
                          <span>Fechamento</span>
                        </div>
                        <span className="text-right">
                          {item.DATAHORAFECHAMENTO
                            ? new Date(item.DATAHORAFECHAMENTO).toLocaleString(
                                "pt-BR",
                                {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                }
                              )
                            : ""}
                        </span>
                      </p>
                    ) : null}
                    <p className="relative overflow-visible group flex gap-1 items-center w-fit">
                      <FaUser className="" size={iconSize} />
                      <div className="absolute text-black text-sm shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-sm   p-2 bg-gray-100">
                        <span>Operador</span>
                      </div>
                      <span className="w-[20ch] overflow-hidden whitespace-nowrap text-ellipsis">
                        {item.RESPONSAVEL}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <ModalFechamento
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
          >
            <ModalContent
              pdv={currentPDV}
              turno={currentTurno}
              maxTurno={maxTurno}
              onClose={() => setModalOpen(false)}
            />
          </ModalFechamento>
        </div>
      )}
    </Layout>
  );
}

export default Dashboard;
